import React from 'react';
import classnames from 'classnames';

var styles = {"flexible":"_8VpnrMKmsqQ-","smallestGap":"ooF1YfV4Usc-","smallerGap":"ppCZfXq-Kqc-","smallGap":"tElkBalXH3g-","baseGap":"_4u3OwUKxxbg-","largeGap":"RL7CJla0AAI-","noneGap":"fV4cvFYkhgo-","startAlign":"_04xVVjZgr-0-","centerAlign":"Nc3zrqHHYSg-","endAlign":"qA-v50wBX1U-"};

function Flex({ align = "center", children, direction = "row", gap = "base", template, }) {
    return (React.createElement("div", { className: classnames(styles.flexible, {
            [styles[`${gap}Gap`]]: Boolean(gap),
            [styles[`${align}Align`]]: Boolean(align),
        }), style: generateGridStylesFromTemplate(direction, template) }, children));
}
function generateGridStylesFromTemplate(direction, layoutTemplate) {
    const containerStyles = {};
    const templateKeys = {
        row: "gridTemplateColumns",
        column: "gridTemplateRows",
    };
    const templateValues = {
        grow: "1fr",
        shrink: "max-content",
    };
    containerStyles[templateKeys[direction]] = layoutTemplate
        .map(key => templateValues[key])
        .join(" ");
    return containerStyles;
}

export { Flex as F };
